export default "__VITE_ASSET__f3c82f6c__"